<div class="screen-title px-2 py-1"><i [ngClass]="iconClass"></i><span class="mx-2">{{title +
        this.obterTituloComplementar()}}</span></div>